import { render, staticRenderFns } from "./CreateAPIToken.vue?vue&type=template&id=6ad4b1bd&scoped=true&"
import script from "./CreateAPIToken.vue?vue&type=script&lang=js&"
export * from "./CreateAPIToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4b1bd",
  null
  
)

export default component.exports